import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaRegClock, FaRegSave, FaArrowLeft, FaKeyboard, FaClock } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import PageCreateHeader from "../../components/PageCreateHeader";

const EditShift = () => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(null);
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);


useEffect(() => {
  const role = localStorage.getItem("role"); // Atau cara lain mengambil role
  setUserRole(role);

  if (role !== "owner") {
    setShowAccessDenied(true);
  }
}, []);
  const { id } = useParams();
  const API_URL = `${process.env.REACT_APP_API_BASE_URL}/v1/shift`;

  const token = localStorage.getItem("token");

  const [shift, setShift] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchShift = async () => {
      try {
        const response = await fetch(API_URL, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          console.error("Gagal mengambil data shift!");
          return;
        }

        const responseData = await response.json();
        console.log("Response dari API:", responseData);

        if (!responseData.success || !Array.isArray(responseData.data)) {
          console.error("Format data dari API tidak sesuai!");
          return;
        }

        const foundShift = responseData.data.find((item) => item.id.toString() === id);
        if (!foundShift) {
          console.error("Shift dengan ID tersebut tidak ditemukan!");
          return;
        }

        console.log("Shift yang ditemukan:", foundShift);

        setShift({
          id: foundShift.id,
          name: foundShift.name || "",
          code: foundShift.code || "S",
          start_time: foundShift.start_time || "00:00", // Hanya jam dan menit
          end_time: foundShift.end_time || "00:00", // Hanya jam dan menit
        });

        setLoading(false);
      } catch (error) {
        console.error("Error saat fetch shift:", error);
        setLoading(false);
      }
    };

    fetchShift();
  }, [API_URL, token, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setShift((prevShift) => ({ ...prevShift, [name]: value }));
  };

  const handleSave = async () => {
    if (!shift.name || !shift.code || !shift.start_time || !shift.end_time) {
      alert("Semua field harus diisi!");
      return;
    }
  
    setSaving(true);
  
    try {
      // Fungsi untuk memastikan format waktu yang benar
      const formatToISO = (time) => {
        const today = new Date().toISOString().split("T")[0]; // Ambil tanggal hari ini (YYYY-MM-DD)
        const [hours, minutes] = time.split(":").map((val) => val.padStart(2, "0")); // Pastikan dua digit
        return `${today}T${hours}:${minutes}:00Z`; // Format sesuai "YYYY-MM-DDTHH:mm:ssZ"
      };
  
      const response = await fetch(`${API_URL}/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          id: shift.id,
          name: shift.name,
          code: shift.code,
          start_time: formatToISO(shift.start_time), // Ubah format waktu ke ISO 8601
          end_time: formatToISO(shift.end_time), // Ubah format waktu ke ISO 8601
        }),
      });
  
      const responseData = await response.json();
      console.log("Response dari API:", responseData);
  
      if (!response.ok) {
        throw new Error(responseData.message || "Gagal mengupdate shift!");
      }
  
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate("/enterprise/shift");
      }, 2000); // Redirect setelah 2 detik
      
    } catch (error) {
      console.error("Error update shift:", error);
      alert(error.message);
    } finally {
      setSaving(false);
    }
  };
  

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col space-y-6 p-6 bg-gray-50 w-full min-w-0">
        <PageCreateHeader
          icon={FaClock}
          title="Edit Shift"
          description="Memuat data shift..."
          breadcrumbs={[
            { label: "Enterprise", to: "/" },
            { label: "Shift", to: "/enterprise/shift" },
            { label: "Edit Shift" },
          ]}
        />
        <p className="text-gray-600">Memuat data shift...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col space-y-6 p-6 bg-gray-50 w-full min-w-0">
      <PageCreateHeader
        icon={FaClock}
        title="Edit Shift"
        description="Perbarui jadwal dan kode shift"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Shift", to: "/enterprise/shift" },
          { label: "Edit Shift" },
        ]}
      />

      <div className="bg-white rounded-2xl shadow-md p-6 border border-gray-100 w-full min-w-0">
        <form className="space-y-5">
          <div className="grid grid-cols-1 gap-6">
            {/* Nama */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center gap-1">
                <MdOutlineDriveFileRenameOutline className="text-green-500" />
                Nama Shift
              </label>
              <input
                type="text"
                name="name"
                value={shift.name}
                onChange={handleChange}
                placeholder="Contoh: Shift Pagi"
                className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-sm"
              />
            </div>

            {/* Code */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center gap-1">
                <FaKeyboard className="text-green-500" />
                Kode Shift
              </label>
              <div className="flex space-x-3">
                {["L", "S", "P"].map((code) => (
                  <button
                    key={code}
                    type="button"
                    onClick={() => handleChange({ target: { name: "code", value: code } })}
                    className={`px-4 py-1.5 rounded-full text-sm font-semibold transition-all ${
                      shift.code === code
                        ? "bg-green-500 text-white shadow"
                        : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                    }`}
                  >
                    {code}
                  </button>
                ))}
              </div>
            </div>

            {/* Jam Mulai */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center gap-1">
                <FaRegClock className="text-green-500" />
                Jam Mulai
              </label>
              <input
                type="time"
                name="start_time"
                value={shift.start_time}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-sm"
              />
            </div>

            {/* Jam Pulang */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1 flex items-center gap-1">
                <FaRegClock className="text-green-500" />
                Jam Pulang
              </label>
              <input
                type="time"
                name="end_time"
                value={shift.end_time}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 shadow-sm"
              />
            </div>
          </div>

          {/* Tombol Simpan */}
          <div className="flex justify-end mt-6">
            <button
              type="button"
              onClick={handleSave}
              disabled={saving}
              className={`flex items-center gap-2 px-6 py-2 rounded-full text-white font-medium transition-all ${
                saving
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-green-500 hover:bg-green-600 shadow"
              }`}
            >
              <FaRegSave />
              {saving ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
{/* Modal Berhasil */}
{showSuccessModal && (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
    <div className="bg-white p-6 rounded-xl shadow-xl w-[90%] max-w-sm text-center">
      <h2 className="text-xl font-bold text-green-600 mb-2">Berhasil!</h2>
      <p className="text-gray-700">Shift berhasil diperbarui.</p>
    </div>
  </div>
)}

      {/* Modal Akses Ditolak */}
      {showAccessDenied && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-xl w-[90%] max-w-md">
            <h2 className="text-xl font-bold text-red-600 mb-4 text-center">Akses Ditolak</h2>
            <p className="text-gray-600 mb-5 text-center">
              Anda tidak memiliki hak akses untuk memasuki halaman ini.
            </p>
            <button
              onClick={() => navigate("/dashboard")}
              className="w-full bg-red-500 text-white py-2 rounded-full font-medium hover:bg-red-600 transition-all"
            >
              <FaArrowLeft className="inline mr-2" />
              Kembali ke Dashboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditShift;
